// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__3mtGJ","caption":"Placeholder_caption__1mYvV","content":"Placeholder_content__2dXac","contentCol":"Placeholder_contentCol__1ktSD"};